import { Box, Typography, Button, TextField } from "@mui/material";
import { useState } from "react";
import API from "../../../api";
import WarningDialog from "../../../components/WarningDialog";
import {
  startToast,
  updateToastError,
  updateToastSuccess,
} from "../../../utils/notification-loading";

const ChangeIpCard = () => {
  const [ipAddress, setIpAddress] = useState("");
  const [gateway, setGateway] = useState("");
  const [dns, setDNS] = useState("");

  const [errorIpAddress, setErrorIpAddress] = useState(false);
  const [errorGateway, setErrorGateway] = useState(false);
  const [errorDNS, setErrorDNS] = useState(false);

  // Dialog conferma reset DHCP
  const [resetDhcpDialogOpen, setResetDhcpDialogOpen] = useState(false);

  function validateIPwithSubnetMask(ip) {
    if (!ip) return true;

    const regexp =
      /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\/([0-9]|[1-2][0-9]|3[0-2])$/;

    return regexp.test(ip);
  }

  function validateIP(ip) {
    if (!ip) return true;

    const regexp =
      /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;

    return regexp.test(ip);
  }

  // Valida uno o più DNS separati da virgola
  function validateDNS(dnsValue) {
    if (!dnsValue) return true;

    const dnsList = dnsValue.split(",");

    return dnsList.every((dnsAddress) =>
      validateIP(dnsAddress.trim())
    );
  }

  const handelChangeIpAddress = (e) => {
    const { value } = e.target;

    setIpAddress(value);
    setErrorIpAddress(!validateIPwithSubnetMask(value));
  };

  const handelChangeGateway = (e) => {
    const { value } = e.target;

    setGateway(value);
    setErrorGateway(!validateIP(value));
  };

  const handleChangeDNS = (e) => {
    const { value } = e.target;

    setDNS(value);
    setErrorDNS(!validateDNS(value));
  };

  const ForChangeLECSIP = () => {
    const payload = {
      action: "add",
      ip: ipAddress,
      gateway: gateway,
      dns: dns,
    };

    startToast();

    API.setStaticIp(payload)
      .then(() => {
        setIpAddress("");
        setGateway("");
        setDNS("");

        updateToastSuccess(
          "LECS IP updated. The device will restart and the new IP will be applied."
        );
      })
      .catch((err) => {
        console.error(
          "[ForChangeLECSIP] failed to change LECS IP:",
          err
        );

        updateToastError(
          err.response?.data?.error || "Unexpected error"
        );
      });
  };

  const ToResetDHCP = () => {
    startToast();

    API.setStaticIp({ action: "reset" })
      .then(() => {
        setIpAddress("");
        setGateway("");
        setDNS("");

        updateToastSuccess(
          "DHCP reset. The device will restart and the DHCP configuration will be applied."
        );
      })
      .catch((err) => {
        console.error(
          "[ToResetDHCP] failed to reset DHCP:",
          err
        );

        updateToastError(
          err.response?.data?.error || "Unexpected error"
        );
      });
  };

  // Viene chiamata dal pulsante Confirm del WarningDialog
  const handleConfirmResetDHCP = (check) => {
    if (check) {
      setResetDhcpDialogOpen(false);
      ToResetDHCP();
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "rgba(69, 144, 149, 0.05)",
        borderRadius: 2,
        border: "1px solid rgba(69, 144, 149, 0.1)",
        p: 3,
      }}
    >
      <Typography
        sx={{
          fontSize: 18,
          fontWeight: 600,
          mb: 2,
          color: "#449095",
        }}
      >
        Change LECS IP Section
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <TextField
          label="New IP (with subnet mask)"
          fullWidth
          value={ipAddress}
          onChange={handelChangeIpAddress}
          error={errorIpAddress}
          helperText={
            errorIpAddress
              ? "Enter a valid IP with CIDR (e.g., 192.168.7.1/24)"
              : ""
          }
        />

        <TextField
          label="New Gateway"
          fullWidth
          value={gateway}
          onChange={handelChangeGateway}
          error={errorGateway}
          helperText={
            errorGateway
              ? "Enter a valid IP (e.g., 192.168.1.1)"
              : ""
          }
        />

        <TextField
          label="New DNS"
          placeholder="ex. 1.1.1.1, 8.8.8.8, ..."
          fullWidth
          value={dns}
          onChange={handleChangeDNS}
          error={errorDNS}
          helperText={
            errorDNS
              ? "Enter one or more valid DNS IPs separated by commas"
              : ""
          }
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mt: 2,
          }}
        >
          <Button
            disabled={
              errorDNS ||
              errorGateway ||
              errorIpAddress ||
              !dns ||
              !ipAddress ||
              !gateway
            }
            variant="contained"
            fullWidth
            onClick={ForChangeLECSIP}
            sx={{
              backgroundColor: "#2d2d2d !important",
              "&:hover": {
                backgroundColor: "#eaeaea !important",
                color: "#131C2D",
              },
            }}
            style={{
              fontWeight: "bold",
            }}
          >
            CHANGE LECS IP
          </Button>

          <Button
            variant="contained"
            fullWidth
            onClick={() => setResetDhcpDialogOpen(true)}
            sx={{
              backgroundColor: "#2d2d2d !important",
              "&:hover": {
                backgroundColor: "#eaeaea !important",
                color: "#131C2D",
              },
            }}
            style={{
              fontWeight: "bold",
            }}
          >
            RESET DHCP ON LECS
          </Button>
        </Box>
      </Box>

      <WarningDialog
        open={resetDhcpDialogOpen}
        setOpen={setResetDhcpDialogOpen}
        setCheck={handleConfirmResetDHCP}
        message="Are you sure you want to reset the LECS network configuration to DHCP?"
      />
    </Box>
  );
};

export default ChangeIpCard;